import axios from 'axios'

import { BASE_API_V2_URL } from 'src/constants'
import { getSecretHeader } from 'src/utils'

axios.defaults.baseURL = BASE_API_V2_URL

export const loadResources = async (lng: string) => {
  const resp = await axios.get(`locales/${lng}`, {
    // the public /v2/locales endpoint never used the user token: don't put it in the URL
    headers: {
      ...getSecretHeader(),
    },
  })
  return resp.data
}
